import React, { useContext } from 'react'
import { Spinner, Text, View } from 'oio-react'
import { useRouteMatch } from 'react-router-dom'
import InitiativeMoreButton from 'src/apps/Initiative/components/MoreButton'
import InitiativeStatusBanner from 'src/apps/Initiative/components/StatusBanner'
import MessageFeed from 'src/apps/Messages/components/Feed'
import ModalRoute from 'src/components/utils/ModalRoute'
import RichText from 'src/components/utils/RichText'
import { InitiativeHierarchyContext, withInitiativeHierarchyProvider }
   from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'
import BlogSettings from 'src/apps/Blog/apps/Settings'

const BlogView = () => {
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)
   const { initiative, initiativeLoading } = useContext(InitiativeHierarchyContext)

   if (initiativeLoading) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            minHeight="100vh"
            textAlign="center"
            padding="90px"
            borderRadius="6px">
            <Spinner color="#ccc" width="24px" height="24px" />
         </View>
      )
   }

   const initiativeBody = initiative?.body?.elements?.[0]?.body || ''

   return (
      <>
         <View
            borderLeft={`1px solid ${theme.tmpBorderColor}`}
            minHeight="100vh"
            width="100%"
            backgroundColor={theme.tmpContentBackgroundColor}>
            <InitiativeStatusBanner />
            <View
               display="flex"
               justifyContent="center">
               <View
                  width="100%"
                  padding="30px"
                  maxWidth="700px">
                  <View paddingTop="30px[a-c] 40px[d-e] 60px[f]">
                     <Text
                        color={theme.tmpContentTitleColor}
                        size="10"
                        letterSpacing="-1px">
                        {initiative.name}
                     </Text>
                  </View>
                  {initiative.subtitle && (
                     <View marginTop="15px">
                        <Text
                           color="#666"
                           size="4"
                           lineHeight="150%">
                           {initiative.subtitle}
                        </Text>
                     </View>
                  )}
                  <View
                     display="flex"
                     justifyContent="space-between"
                     alignItems="center"
                     marginTop="15px">
                     <Text color="#888" size="2">
                        By
                        &nbsp;
                        <span
                           style={{
                              opacity: '0.8',
                              fontWeight: '600 !important'
                           }}>
                           {initiative.addedBy.fullName}
                        </span>
                        &nbsp;&nbsp;&#183;&nbsp;&nbsp;
                        {initiative.dateAdded}
                     </Text>
                     <InitiativeMoreButton
                        color="#eee"
                        iconColor="#444"
                     />
                  </View>
                  <View
                     marginTop="40px"
                     display={initiative.coverMedia ? 'block' : 'none'}
                     paddingTop="56.25%"
                     backgroundColor="#000"
                     backgroundSize="cover"
                     backgroundImage={initiative.coverMedia &&
                        `url(${initiative.coverMedia?.file.thumbnailUrlW480})`
                     }
                  />
                  <View float="left" width="100%" padding="40px 0 0 0">
                     <Text
                        size="3"
                        lineHeight="160%"
                        color="#666">
                        <RichText html={initiativeBody} />
                     </Text>
                  </View>
                  <View float="left" width="100%" padding="30px 0px">
                     {initiative.appsMessagesEnabled && (
                        <MessageFeed
                           currentUserCanModerate={initiative.currentUserCanModerate}
                           displayMode="feed"
                           hasUnreadEntries={initiative.thread.hasUnreadEntries}
                           messageLastViewed={initiative.thread.messageLastViewed}
                           textColor={theme.tmpContentTextColor}
                        />
                     )}
                  </View>
               </View>
            </View>
         </View>
         {initiative.currentUserCanEdit && (
            <ModalRoute path={`${match.path}/settings`}>
               {({ open, onCloseComplete, onCloseTrigger }) => (
                  <BlogSettings
                     modalOnCloseComplete={onCloseComplete}
                     modalOnCloseTrigger={onCloseTrigger}
                     modalOpen={open}
                  />
               )}
            </ModalRoute>
         )}
      </>
   )
}

export default withInitiativeHierarchyProvider({ slugParam: 'initiativeSlug' })(BlogView)
